import { render, staticRenderFns } from "./PageLayoutComponent.vue?vue&type=template&id=a40c02e2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a40c02e2')) {
      api.createRecord('a40c02e2', component.options)
    } else {
      api.reload('a40c02e2', component.options)
    }
    module.hot.accept("./PageLayoutComponent.vue?vue&type=template&id=a40c02e2&", function () {
      api.rerender('a40c02e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/PageLayoutComponent.vue"
export default component.exports